import React from 'react'
import styled from 'styled-components'
import type { TFunction } from 'i18next'
import { Icon } from '../../../atoms/Icon'

interface RegBLLinkProps {
  egid: number
  t?: TFunction
  label?: string
  variant?: 'inline' | 'button' | 'footer'
  className?: string
}

const StyledLink = styled.a<{ $variant: 'inline' | 'button' | 'footer' }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: ${({ $variant, theme }) => {
    if ($variant === 'footer') return theme.typography.fontSize.small
    if ($variant === 'button') return theme.typography.fontSize.body
    return theme.typography.fontSize.small
  }};
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  transition: all 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryHover};
    text-decoration: underline;
  }

  ${({ $variant, theme }) =>
    $variant === 'button' &&
    `
    padding: 8px 16px;
    border: 1px solid ${theme.colors.border.default};
    border-radius: ${theme.borderRadius.default};
    background: ${theme.colors.background.primary};

    &:hover {
      background: ${theme.colors.background.secondary};
      text-decoration: none;
    }
  `}

  ${({ $variant }) =>
    $variant === 'footer' &&
    `
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  `}
`

export const RegBLLink: React.FC<RegBLLinkProps> = ({
  egid,
  t,
  label,
  variant = 'inline',
  className,
}) => {
  const url = `https://www.housing-stat.ch/fr/query/egid.html?egid=${egid}`
  const displayLabel =
    label || (t ? t('regblLink.viewInRegBL') : 'View in RegBL')
  const titleText = t
    ? t('regblLink.viewBuildingTitle', { egid })
    : `View building ${egid} in Swiss Federal Building Registry`

  return (
    <StyledLink
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      $variant={variant}
      className={className}
      title={titleText}
    >
      <Icon name="external-link" size="small" />
      {displayLabel}
    </StyledLink>
  )
}
